<template>
  <div class="action">
    <div class="vertical-line" :style="{ height: tail + 'px' }"></div>
    <div class="body">
      <div class="action-icon">
        <svg
          v-if="action.action == 'schedule call' || action.action == 'text re-schedule call'"
          class="svg-action"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M22.8623041,6.4771831 L13.5686636,6.4771831 C13.5290323,6.12976526 13.382765,5.80741784 13.1409217,5.55164319 C12.8413825,5.23474178 12.4369585,5.06028169 12.0023041,5.06028169 L6.67198157,5.06028169 C6.23723502,5.06028169 5.83290323,5.23474178 5.53336406,5.5515493 C5.23382488,5.8684507 5.07788018,6.28666667 5.09410138,6.72929577 L5.36138249,13.9882629 C5.37963134,14.4824413 5.38,15.3179343 5.36221198,15.8126761 L5.09317972,23.3000939 C5.07732719,23.7425352 5.23354839,24.1606573 5.53327189,24.4773709 C5.83290323,24.7940845 6.23732719,24.9684507 6.6718894,24.9684507 L12.0021198,24.9684507 C12.436682,24.9684507 12.841106,24.7940845 13.1407373,24.4773709 C13.3157604,24.2923944 13.4402765,24.0723005 13.5117051,23.8334272 L22.8621198,23.8334272 C24.0056221,23.8334272 24.9358525,22.8857277 24.9358525,21.7207512 L24.9358525,8.58985915 C24.9360369,7.42497653 24.0058065,6.4771831 22.8623041,6.4771831 Z M12.1457143,23.4997183 C12.1197235,23.5271362 12.0737327,23.5599061 12.0023041,23.5599061 L6.67198157,23.5599061 C6.600553,23.5599061 6.55456221,23.5271362 6.52857143,23.4997183 C6.50258065,23.4723005 6.4721659,23.4243192 6.47483871,23.3515493 L6.74387097,15.8641315 C6.76294931,15.3320188 6.76258065,14.4667606 6.74294931,13.9353052 L6.4756682,6.67643192 C6.47299539,6.60384977 6.50322581,6.55596244 6.52912442,6.5286385 C6.55493088,6.50131455 6.60073733,6.46873239 6.67198157,6.46873239 L12.002212,6.46873239 C12.0734562,6.46873239 12.1192627,6.50131455 12.1451613,6.5286385 C12.1709677,6.55605634 12.2011982,6.60384977 12.1986175,6.67643192 L11.9313364,13.9353991 C11.9117972,14.4675117 11.9113364,15.3326761 11.9304147,15.8642254 L12.1993548,23.3516432 C12.2020276,23.4243192 12.1716129,23.4723005 12.1457143,23.4997183 Z M23.5535484,21.7207512 C23.5535484,22.109108 23.2435023,22.4249765 22.8623041,22.4249765 L13.5495853,22.4249765 L13.3120737,15.81277 C13.2942857,15.3185915 13.2947465,14.4830986 13.3129032,13.9882629 L13.5376037,7.8857277 L22.8623963,7.8857277 C23.2435945,7.8857277 23.5536406,8.20159624 23.5536406,8.58995305 L23.5536406,21.7207512 L23.5535484,21.7207512 Z M21.9180645,9.61521127 L14.6610138,9.61521127 C14.2792627,9.61521127 13.9697696,9.93051643 13.9697696,10.3194366 C13.9697696,10.7083568 14.2792627,11.023662 14.6610138,11.023662 L21.9180645,11.023662 C22.2998157,11.023662 22.6093088,10.7083568 22.6093088,10.3194366 C22.6093088,9.93051643 22.2998157,9.61521127 21.9180645,9.61521127 Z M15.6228571,13.0598122 L14.8454378,13.0598122 C14.4636866,13.0598122 14.1541935,13.3751174 14.1541935,13.7640376 C14.1541935,14.1529577 14.4636866,14.4682629 14.8454378,14.4682629 L15.6228571,14.4682629 C16.0046083,14.4682629 16.3141014,14.1529577 16.3141014,13.7640376 C16.3141014,13.3751174 16.0046083,13.0598122 15.6228571,13.0598122 Z M18.6320737,13.0598122 L17.8546544,13.0598122 C17.4729032,13.0598122 17.1634101,13.3751174 17.1634101,13.7640376 C17.1634101,14.1529577 17.4729032,14.4682629 17.8546544,14.4682629 L18.6320737,14.4682629 C19.0138249,14.4682629 19.323318,14.1529577 19.323318,13.7640376 C19.323318,13.3751174 19.0139171,13.0598122 18.6320737,13.0598122 Z M21.6413825,13.0598122 L20.8639631,13.0598122 C20.482212,13.0598122 20.1727189,13.3751174 20.1727189,13.7640376 C20.1727189,14.1529577 20.482212,14.4682629 20.8639631,14.4682629 L21.6413825,14.4682629 C22.0231336,14.4682629 22.3326267,14.1529577 22.3326267,13.7640376 C22.3326267,13.3751174 22.0231336,13.0598122 21.6413825,13.0598122 Z M15.6228571,15.7551174 L14.8454378,15.7551174 C14.4636866,15.7551174 14.1541935,16.0704225 14.1541935,16.4593427 C14.1541935,16.8482629 14.4636866,17.1635681 14.8454378,17.1635681 L15.6228571,17.1635681 C16.0046083,17.1635681 16.3141014,16.8482629 16.3141014,16.4593427 C16.3141014,16.0704225 16.0046083,15.7551174 15.6228571,15.7551174 Z M18.6320737,15.7551174 L17.8546544,15.7551174 C17.4729032,15.7551174 17.1634101,16.0704225 17.1634101,16.4593427 C17.1634101,16.8482629 17.4729032,17.1635681 17.8546544,17.1635681 L18.6320737,17.1635681 C19.0138249,17.1635681 19.323318,16.8482629 19.323318,16.4593427 C19.323318,16.0704225 19.0139171,15.7551174 18.6320737,15.7551174 Z M21.6413825,15.7551174 L20.8639631,15.7551174 C20.482212,15.7551174 20.1727189,16.0704225 20.1727189,16.4593427 C20.1727189,16.8482629 20.482212,17.1635681 20.8639631,17.1635681 L21.6413825,17.1635681 C22.0231336,17.1635681 22.3326267,16.8482629 22.3326267,16.4593427 C22.3326267,16.0704225 22.0231336,15.7551174 21.6413825,15.7551174 Z M15.6228571,18.4505164 L14.8454378,18.4505164 C14.4636866,18.4505164 14.1541935,18.7658216 14.1541935,19.1547418 C14.1541935,19.543662 14.4636866,19.8589671 14.8454378,19.8589671 L15.6228571,19.8589671 C16.0046083,19.8589671 16.3141014,19.543662 16.3141014,19.1547418 C16.3141014,18.7658216 16.0046083,18.4505164 15.6228571,18.4505164 Z M18.6320737,18.4505164 L17.8546544,18.4505164 C17.4729032,18.4505164 17.1634101,18.7658216 17.1634101,19.1547418 C17.1634101,19.543662 17.4729032,19.8589671 17.8546544,19.8589671 L18.6320737,19.8589671 C19.0138249,19.8589671 19.323318,19.543662 19.323318,19.1547418 C19.323318,18.7658216 19.0139171,18.4505164 18.6320737,18.4505164 Z M21.6413825,18.4505164 L20.8639631,18.4505164 C20.482212,18.4505164 20.1727189,18.7658216 20.1727189,19.1547418 C20.1727189,19.543662 20.482212,19.8589671 20.8639631,19.8589671 L21.6413825,19.8589671 C22.0231336,19.8589671 22.3326267,19.543662 22.3326267,19.1547418 C22.3326267,18.7658216 22.0231336,18.4505164 21.6413825,18.4505164 Z"
            id="path-1"
          ></path>
        </svg>

        <svg
          v-else-if="action.action === 're-send at work text'"
          class="svg-action"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <path
            d="M24.302168,8.01773234 L5.67750678,8.01773234 C5.30336043,8.01773234 5,8.32983271 5,8.71475836 L5,22.2642751 C5,22.649145 5.30336043,22.9613011 5.67750678,22.9613011 L24.302168,22.9613011 C24.6762602,22.9613011 24.9796748,22.649145 24.9796748,22.2642751 L24.9796748,8.71475836 C24.9796748,8.32988848 24.6762602,8.01773234 24.302168,8.01773234 Z M23.6246612,21.5673048 L6.35501355,21.5673048 L6.35501355,9.41178439 L23.6246612,9.41178439 L23.6246612,21.5673048 Z M8.1303523,12.695223 L14.6344173,16.8181041 C14.7433604,16.8871933 14.8665583,16.92171 14.9898103,16.92171 C15.1130623,16.92171 15.2362602,16.8871933 15.3452033,16.8181041 L21.8492683,12.695223 C22.1678049,12.4933086 22.2669919,12.0638848 22.0707317,11.736171 C21.8744715,11.4084572 21.4569648,11.3064126 21.1385366,11.5083829 L14.9898103,15.4059294 L8.84113821,11.5083829 C8.52271003,11.3065799 8.10531165,11.4084015 7.90894309,11.736171 C7.71262873,12.063829 7.81176152,12.4933086 8.1303523,12.695223 Z"
            id="path-1"
          ></path>
        </svg>

        <svg v-else class="svg-action" viewBox="0 0 30 30" version="1.1">
          <path
            d="M23.2911397,6.01642237 C23.2857842,6.01772297 23.2803904,6.01879406 23.2750349,6.02024768 L5.42258073,10.8890333 C4.97390338,11.0114052 4.85045878,11.5903285 5.20870444,11.8854899 L10.7649741,16.4629395 L9.7419561,19.5319139 C9.59284327,19.9793229 10.0196778,20.4070315 10.4677813,20.2577294 L13.5367971,19.2347251 L18.1143082,24.7909201 C18.4106977,25.1506145 18.988596,25.0248381 19.1107782,24.5770467 L23.9795911,6.72479437 C23.9811212,6.71917116 23.9822688,6.71347144 23.9836077,6.70780997 C24.0843297,6.28721648 23.7045854,5.91661987 23.2911397,6.01642237 Z M6.79389844,11.7045524 L20.9390361,7.84683605 L11.4372442,15.5299066 L6.79389844,11.7045524 Z M13.3884111,18.0744686 L11.1935683,18.8060985 L11.925208,16.6112852 L19.5704726,10.4292686 L13.3884111,18.0744686 Z M18.2951716,23.2056709 L14.4697277,18.5623876 L22.1529781,9.06068531 L18.2951716,23.2056709 Z"
            id="path-1"
          ></path>
        </svg>
      </div>
      <div class="action-form">
        <primary-select
          type="text"
          name="action"
          class="select-action"
          v-validate="'required'"
          v-model="action.action"
          :disabled="action.action === 're-send at work text' || action.action === 'text re-schedule call'"
        >
          <option v-for="(action, k) in actions" :key="k">{{action}}</option>
        </primary-select>

        <div v-if="action.action === 'schedule call'" class="date-time-container">
          <p class="pimary-input-title">Date and time</p>
          <div class="picker">
            <VueCtkDateTimePicker
              v-model="action.call_date_time"
              class="date-time"
              :label="''"
              :noClearButton="true"
              :min-date="current_date"
              :format="'YYYY-MM-DDTHH:mm:ss.sssZ'"
            />
            <img src="@/assets/Icon/Arrow/Down.svg" class="icon-down" alt>
          </div>
        </div>

        <primary-select
          v-if="action.action !== 'text re-schedule call'"
          type="text"
          name="delay before action"
          class="select-delay"
          v-validate="'required'"
          v-model="action.delay_before_action"
        >
          <option v-for="(delay, k) in delays" :key="k" :value="delay">{{delay}}</option>
        </primary-select>
      </div>
      <div class="close-btn">
        <svg class="svg-close" viewBox="0 0 30 30" version="1.1" @click="removeSelf">
          <g transform="rotate(45) translate(6, -15)">
            <path
              d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
              id="path-1"
            ></path>
          </g>
        </svg>
      </div>
    </div>
    <div class="secondary-action" v-if="action.action === 'schedule call' && action.call_date_time">
      <div class="vertical-line"></div>
      <div class="body">
        <div class="action-icon">
          <svg class="svg-action" viewBox="0 0 30 30" version="1.1">
            <path
              d="M23.2911397,6.01642237 C23.2857842,6.01772297 23.2803904,6.01879406 23.2750349,6.02024768 L5.42258073,10.8890333 C4.97390338,11.0114052 4.85045878,11.5903285 5.20870444,11.8854899 L10.7649741,16.4629395 L9.7419561,19.5319139 C9.59284327,19.9793229 10.0196778,20.4070315 10.4677813,20.2577294 L13.5367971,19.2347251 L18.1143082,24.7909201 C18.4106977,25.1506145 18.988596,25.0248381 19.1107782,24.5770467 L23.9795911,6.72479437 C23.9811212,6.71917116 23.9822688,6.71347144 23.9836077,6.70780997 C24.0843297,6.28721648 23.7045854,5.91661987 23.2911397,6.01642237 Z M6.79389844,11.7045524 L20.9390361,7.84683605 L11.4372442,15.5299066 L6.79389844,11.7045524 Z M13.3884111,18.0744686 L11.1935683,18.8060985 L11.925208,16.6112852 L19.5704726,10.4292686 L13.3884111,18.0744686 Z M18.2951716,23.2056709 L14.4697277,18.5623876 L22.1529781,9.06068531 L18.2951716,23.2056709 Z"
              id="path-1"
            ></path>
          </svg>
        </div>
        <div class="action-form">
          <primary-select type="text" class="select-time" name="action" value="default" disabled>
            <option value="default">Call at {{callTime}}</option>
          </primary-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue")
    // VueCtkDateTimePicker: () => import("@/components/DateTimePicker.vue")
  },
  props: {
    tail: Number,
    action: {
      action: String,
      call_date_time: String,
      delay_before_action: String
    }
  },
  created() {
    this.current_date = format(new Date(), "YYYY-MM-DD");
    console.log("createdddd", this.action.call_date_time)
  },
  data: () => ({
    delays: [
      "immidiately",
      "5 minutes",
      "10 minutes",
      "15 minutes",
      "20 minutes",
      "25 minutes",
      "30 minutes",
      "1 hour",
      "2 hours",
      "4 hours",
      "8 hours",
      "12 hours",
      "1 day"
    ],
    actions: [
      "at work text",
      "schedule call",
      "re-send at work text",
      "text re-schedule call"
    ],
    current_date: null
  }),
  computed: {
    callTime: function() {
      console.log("this.action.call_date_time 111", this.action.call_date_time)
      console.log("format(this.action.call_date_time, 'hh:mm')", format(this.action.call_date_time, "hh:mm"))
      return format(this.action.call_date_time, "hh:mm");
    },
    callFullTime: function() {
      console.log("this.action.call_date_time222222 ", this.action.call_date_time)
      console.log("format(this.action.call_date_time, 'YYYY-MM-DDTHH:mm:ss.sssZ')", format(this.action.call_date_time, "YYYY-MM-DDTHH:mm:ss.sssZ"))
      return format(this.action.call_date_time, "YYYY-MM-DDTHH:mm:ss.sssZ");
    }
  },
  methods: {
    removeSelf: function() {
      this.$emit("removeAction");
    }
  }
};
</script>

<style lang="scss">
.action {
  flex-direction: column;
  .vertical-line {
    width: 0;
    border-left: 2px solid #bdbfd8;
    margin-left: 19px;
  }
  .body {
    display: inline-flex;
    .action-icon {
      height: 60px;
      width: 40px;
      border-radius: 30px;
      background-color: #55616e;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
      text-align: center;
      padding: 15px 0;
      .svg-action {
        height: 30px;
        width: 30px;
        fill: #ffffff;
      }
    }
    .action-form {
      display: inline-flex;
      margin-left: 25px;
      .date-time-container {
        width: 210px;
        margin-left: 10px;
        .date-time {
          margin: 0;
          input {
            border: 1px solid #edeef3;
            height: 40px;
            min-height: 40px;
          }
        }
        .picker {
          display: flex;
          img {
            z-index: 100;
            margin-left: -34px;
          }
          .field-input {
            padding-top: 0;
          }
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
      }
      .select-action {
        width: 300px;
      }
      .select-delay {
        width: 210px;
        margin-left: 10px;
      }
    }
    .close-btn {
      display: inline-flex;
      padding-top: 20px;
      margin-left: 10px;
      align-items: center;
      .svg-close {
        width: 30px;
        height: 30px;
        fill: #55616e;
        cursor: pointer;
      }
    }
  }
  .secondary-action {
    .vertical-line {
      height: 30px;
    }
    .body {
      display: inline-flex;
      .action-icon {
        height: 60px;
        width: 40px;
        border-radius: 30px;
        background-color: #55616e;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        text-align: center;
        padding: 15px 0;
        .svg-action {
          height: 30px;
          width: 30px;
          fill: #ffffff;
        }
      }
      .action-form {
        display: inline-flex;
        margin-left: 25px;
        .select-time {
          width: 300px;
        }
      }
    }
  }
}
</style>